import React, { useState } from 'react';
import axios from 'axios';
import { API_URL } from 'constants';
import {
  Box,
  Input,
  Button,
  Text,
  VStack,
  Alert,
  AlertIcon,
} from '@chakra-ui/react';

const ForgotPassword = ({ resetMasterPwdOnly = false, centered = true }) => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(
        `${API_URL}/api/auth/pharmacist-dashboard/forgot-password`,
        { email, resetMasterPwdOnly }
      );
      setMessage(response.data.message);
    } catch (err) {
      setError(err.response?.data?.message || 'Une erreur est survenue. Veuillez réessayer.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems={centered ? "center" : "flex-start"}
      height={centered ? "100vh" : "auto"}
      px={4}
      mt={centered ? 0 : 4}
    >
      <VStack spacing={4} align="center" width="100%">
        <Text fontSize="2xl" fontWeight="bold" color="teal.500">
          Réinitialiser votre mot de passe
        </Text>
        <Text fontSize="md" color="gray.600" textAlign="center">
        Veuillez entrer ci-dessous l'adresse email que vous utilisez pour vous connecter à vos comptes Saydalid.<br />Vous recevrez un lien pour réinitialiser votre mot de passe.
        </Text>
        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <VStack spacing={4} align="center">
            <Input
              type="email"
              placeholder="Adresse email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              isRequired
              width={centered ? '50%' : '100%'}
            />
            <Button
              type="submit"
              colorScheme="teal"
              isLoading={loading}
              loadingText="Envoi en cours ..."
            >
              Envoyer
            </Button>
          </VStack>
        </form>
        {message && (
          <Alert status="success" width={centered ? '50%' : '100%'}>
            <AlertIcon />
            {message}
          </Alert>
        )}
        {error && (
          <Alert status="error" width={centered ? '50%' : '100%'}>
            <AlertIcon />
            {error}
          </Alert>
        )}
      </VStack>
    </Box>
  );
};

export default ForgotPassword;